// Conventions for "Launch Day Special Draws", stored in the shared backend via
// metadata_tags so the homepage countdown + launch section stay in sync.
// Multiple competitions can be flagged as launch specials (all tagged __launch__).
export const LAUNCH_TAG = "__launch__";
export const LAUNCH_AT_PREFIX = "launch_at:";

export const isLaunchComp = (comp) => !!comp && (
  comp.launch_draw === true || comp.launch_day === true ||
  (comp.metadata_tags || []).includes(LAUNCH_TAG)
);

// All competitions flagged as launch specials.
export const findLaunchComps = (comps) => (comps || []).filter(isLaunchComp);

// First launch competition (kept for backwards compatibility).
export const findLaunchComp = (comps) => (comps || []).find(isLaunchComp);

export const getLaunchAt = (comp) => {
  if (!comp) return null;
  const t = (comp.metadata_tags || []).find((x) => typeof x === "string" && x.startsWith(LAUNCH_AT_PREFIX));
  return t ? t.slice(LAUNCH_AT_PREFIX.length) : (comp.auto_draw_at || comp.ends_at || null);
};

// Earliest go-live date across all launch draws (drives the countdown).
export const earliestLaunchAt = (comps) => {
  const dates = findLaunchComps(comps).map(getLaunchAt).filter(Boolean).sort();
  return dates[0] || null;
};
